<template>
  <div class="header">
    <div class="title">
      <div class="title-left">
        <img src="@/assets/images/logo.png" alt="" >
        <span>深圳市公标知识产权鉴定评估中心</span>
      </div>
      <div class="title-right">
        <div class="app">
          <span>{{ $t('platform.header.title2') }}</span>
          <div class="union">
            <img src="@/assets/images/home/gbApp.png" alt="">
            <p>{{ $t('platform.header.title4') }}</p>
          </div>
        </div>
        <!--        <img src="@/assets/images/home/cnLanguage.png" alt="" class="language">-->
        <div class="login" @click="goNext(1)">{{ !userInfo.id ? '注册/登录': '进入平台' }}</div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    userInfo:{
      type:Object,
      default(){
        return {}
      }
    }
  },
  components: {},
  computed: {},
  created() {
  },
  mounted() {
  },
  methods: {
    goNext(type) {
      console.log(type)
      switch (type) {
        case 1:
          this.$router.push('login')
          break
      }
    }
  },
}

</script>
<style scoped lang='less'>
.header {
  height: 80px;
  background: #002972;

  .title {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    align-content: center;
    height: 80px;
  }

  .title-left {
    display: flex;
    align-items: center;

    img {
      width: 42px;
      height: 42px;
    }

    span {
      font-weight: 500;
      font-size: 30px;
      color: #FFFFFF;
      line-height: 35px;
      letter-spacing: 2px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }
  }

  .title-right {
    color: #FFFFFF;
    display: flex;
    align-items: center;

    .app {
      position: relative;
      margin: 0 30px 0 30px;

      span {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        letter-spacing: 1px;
        cursor: pointer;
      }

      .union {
        position: absolute;
        top: 28px;
        right: -64px;
        background: url('../../assets/images/home/unionWhite.png') no-repeat;
        background-size: 210px 240px;
        width: 210px;
        height: 240px;
        z-index: 999;
        display: none;
        flex-direction: column;
        align-items: center;
        padding-top: 24px;
        transition: all .3s ease;

        img {
          width: 180px;
          height: 180px;
          margin: 0 auto;
        }

        p {
          font-size: 14px;
          color: #333;
        }
      }

      &:hover {
        .union {
          display: flex;
        }
      }
    }

    .language {
      width: 48px;
      height: 25px;
      margin: 0 30px 0 30px;
      cursor: pointer;
    }

    .login {
      font-size: 16px;
      color: #FFFFFF;
      line-height: 19px;
      letter-spacing: 1px;
      padding: 8px 17px;
      border-radius: 37px 37px 37px 37px;
      border: 1px solid #FFFFFF;
      cursor: pointer;
      transition: all .3s ease;

      &:hover {
        color: #002972;
        background: #fff;
        border-color: #002972;
      }
    }
  }
}
</style>